import { z } from 'zod';

export const IOwnersSchema = z.object({
  tenantId: z.string().uuid(),
  aadId: z.string().uuid(),
  displayName: z.string().nullish(),
  userPrincipalName: z.string().email(),
  isAdministrator: z.boolean()
});

export type IAppOwner = z.infer<typeof IOwnersSchema>;